import React from 'react';

import Shake from 'components/animations/shake';
import './text-input.scss';

interface TextInputProps {
  id: string;
  name: string;
  label?: string;
  info?: string;
  placeholder?: string;
  type?: string;
  error?: boolean;
  readonly?: boolean;
  maxLength?: number | undefined;
  registerRef: (arg: any) => void;
  required?: boolean;
  value?: any;
  onChange?: (arg: any) => void;
  className?: string;
}

export default function TextInput({
  id,
  label,
  info,
  placeholder,
  error,
  registerRef,
  name,
  type = 'text',
  maxLength = undefined,
  readonly,
  required,
  value,
  onChange,
  className,
}: TextInputProps): React.ReactElement {
  return (
    <Shake on={!!error} className={`${className}`}>
      <div className={`text-input ${error ? 'error' : ''}`}>
        {label && (
          <label htmlFor={name}>
            {label}
            <span className='info'>{info}</span>
          </label>
        )}
        <input
          id={id}
          type={type}
          placeholder={placeholder}
          readOnly={readonly}
          {...registerRef(name)}
          maxLength={maxLength}
          required={required}
          value={value}
          onChange={onChange}
        />
      </div>
    </Shake>
  );
}
